import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import moment from 'moment';
import WaitIcon from '../../Image/WaitIcon.png';

import VideoViewModal from '../../Model/EventDetailModel/VideoViewModal';

import CrownIcon from '../../Image/CrownIcon.png';
import { useTranslation } from 'react-i18next';

export default function GorillaThrowdownDetailPage() {
  const { i18n } = useTranslation();

  const changeLanguageToKo = () => i18n.changeLanguage('ko');
  const changeLanguageToEn = () => i18n.changeLanguage('en');

  const params = useParams();

  const navigate = useNavigate();

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  })
  const [nowSection, setNowSection] = useState('A');
  const [title, setTitle] = useState('');

  const [language, setLanguage] = useState('Korea');

  const TopLevelRef = useRef();

  // 페이지 이름 변경내역 업로드 //
  useEffect(() => {
    try {
      window.ReactNativeWebView.postMessage(JSON.stringify({ pageName: 'Gorilla Throwdown', isAvailableGoback: true }));
    }
    catch (e) {
      console.log("Web Message Post Error : " + e);
    }
  }, []);

  // Token 저장 //
  useEffect(() => {
    (
      async () => {
        await window.localStorage.setItem('Token', 'Bearer ' + params.token);
      }
    )();
  }, [params])

  // // 화면 크기 추출후 총 비디오 박스 크기 계산 //
  // useEffect(() => {
  //   // var finalSize = windowSize.width * 0.3208;
  //   let totalVideoWidth = windowSize.width * 0.9033;
  //   let totalVideoHeight = totalVideoWidth * 0.5614;

  //   let modalVideoWidth = windowSize.width;
  //   let modalVideoHeight = modalVideoWidth * 0.5603;

  //   setTotalVideoWidth(totalVideoWidth);
  //   setTotalVideoHeight(totalVideoHeight);

  //   setModalVideoWidth(modalVideoWidth);
  //   setModalVideoHeight(modalVideoHeight);
  // }, [windowSize])

  // Message Detect Save And Delete //
  useEffect(() => {
    // Android //
    document.addEventListener('message', handleMassage);

    // IOS //
    window.addEventListener('message', handleMassage);

    return () => {
      // Android //
      document.removeEventListener('message', handleMassage);

      // IOS //
      window.removeEventListener('message', handleMassage);
    }
  }, [])

  // Section 저장 //
  useEffect(() => {
    (
      async () => {
        if (nowSection === '') {
          var prevSection = await window.localStorage.getItem('NowSection') === 'null' ? 'A' : window.localStorage.getItem('NowSection');

          setNowSection(prevSection);
        }
        else await window.localStorage.setItem('NowSection', nowSection);
      }
    )();

    let title = 'Gorilla Throwdown';

    setTitle(title);

    TopLevelRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }, [nowSection])

  // React Native에서 웹으로 보내는 데이터 handler //
  function handleMassage(e) {
    // 언어 정보 받아오기 //
    let language = JSON.parse(e.data).language;

    if (language === 'Korea') changeLanguageToKo();
    else if (language === 'English') changeLanguageToEn();

    if (language !== undefined) setLanguage(language);
  }

  // Section Button 클릭시 //
  function onClickSectionButton(section) {
    // 날짜별 공개시점 정리 //
    setNowSection(section);
  }

  // 순위표 버튼 클릭시 //
  function onClickGoRanking() {
    // if (moment().isBefore(moment('2024-06-01T10:00:00'))) alert('6월 1일 10시 오픈 예정입니다');
    // else navigate('/rank/r2c/' + 43);
    navigate('/rank/gorilla_throwdown/');
  }

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      <TopLineWrapper>
        <TitleWrapper>
          <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#4F4F4F'>{title}</Text>
        </TitleWrapper>
      </TopLineWrapper>
      <DivisionLine />
      <SectionButtonWrapper>
        <SectionButton isClicked={nowSection === 'A'} onClick={() => onClickSectionButton('A')}>
          <Text fontFamily='Poppins-Bold' fontSize={14} color='#FFFFFF'>EVENT1</Text>
        </SectionButton>
        <SectionButton style={{ width: '87px' }} isClicked={nowSection === 'B'} onClick={() => onClickSectionButton('B')}>
          <Text fontFamily='Poppins-Bold' fontSize={14} color='#FFFFFF'>EVENT2&3</Text>
        </SectionButton>
        <SectionButton isClicked={nowSection === 'C'} onClick={() => onClickSectionButton('C')}>
          <Text fontFamily='Poppins-Bold' fontSize={14} color='#FFFFFF'>EVENT3</Text>
        </SectionButton>
        <TotalSectionButton onClick={onClickGoRanking}>
          <CrownImage src={CrownIcon} />
        </TotalSectionButton>
      </SectionButtonWrapper>
      <DivisionLine style={{ margin: '20px 0px 0px 0px' }} />
      {/* {
        moment().isBefore(moment('2024-06-22T00:00:00')) ?
          <WaitWrapper>
            <WaitImage src={WaitIcon} />
            <Text style={{ marginTop: '8px' }} fontFamily='NotoSansKR-Medium' fontSize={14} color='#BDBDBD'>Final Fit Force Team League</Text>
            <Text style={{ marginTop: '2px' }} fontFamily='NotoSansKR-Medium' fontSize={14} color='#BDBDBD'>2024.06.22 Open</Text>
          </WaitWrapper>
          :
          <WodImageWrapper>
            {nowSection === 'A' && <WodImage src='https://picture.link-zone.org/event/GorillaThrowdown/GorillaEvent1Wod.png' />}
            {nowSection === 'B' && <WodImage src='https://picture.link-zone.org/event/GorillaThrowdown/GorillaEvent2&3Wod.png' />}
            {nowSection === 'C' && <WodImage src='https://picture.link-zone.org/event/GorillaThrowdown/GorillaEvent4Wod.png' />}
          </WodImageWrapper>
      } */}
      <WodImageWrapper>
        {
          nowSection === 'A' &&
          <TitleWrapper style={{ width: '90.33%', marginBottom: '16px' }}>
            <SectionBox>
              <Text fontFamily='Poppins-Bold' fontSize={14} color='#FFFFFF'>EVENT 1</Text>
            </SectionBox>
            <TitleBox>
              <Text fontFamily='NotoSansKR-Medium' fontSize={13} color='#333333'>Death By Rowing</Text>
            </TitleBox>
          </TitleWrapper>
        }
        {
          nowSection === 'B' &&
          <TitleWrapper style={{ width: '90.33%', marginBottom: '16px' }}>
            <SectionBox style={{ width: '90px' }}>
              <Text fontFamily='Poppins-Bold' fontSize={14} color='#FFFFFF'>EVENT 2&3</Text>
            </SectionBox>
            <TitleBox>
              <Text fontFamily='NotoSansKR-Medium' fontSize={13} color='#333333'>For time with Amrap</Text>
            </TitleBox>
          </TitleWrapper>
        }
        {
          nowSection === 'C' &&
          <TitleWrapper style={{ width: '90.33%', marginBottom: '16px' }}>
            <SectionBox>
              <Text fontFamily='Poppins-Bold' fontSize={14} color='#FFFFFF'>EVENT 4</Text>
            </SectionBox>
            <TitleBox>
              <Text fontFamily='NotoSansKR-Medium' fontSize={13} color='#333333'>Amrap 9min</Text>
            </TitleBox>
          </TitleWrapper>
        }
      </WodImageWrapper>
      <WodImageWrapper>
        {nowSection === 'A' && <WodImage src='https://picture.link-zone.org/event/GorillaThrowdown/GorillaEvent1Wod.png' />}
        {nowSection === 'B' && <WodImage src='https://picture.link-zone.org/event/GorillaThrowdown/GorillaEvent2&3Wod.png' />}
        {nowSection === 'C' && <WodImage src='https://picture.link-zone.org/event/GorillaThrowdown/GorillaEvent4Wod.png' />}
      </WodImageWrapper>
      <RuleBookTitleWrapper>
        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#333333'>RULE BOOK</Text>
      </RuleBookTitleWrapper>
      <WodImageWrapper>
        {nowSection === 'A' && <WodImage src='https://picture.link-zone.org/event/GorillaThrowdown/GorillaEvent1RuleBook.png' />}
        {nowSection === 'B' && <WodImage src='https://picture.link-zone.org/event/GorillaThrowdown/GorillaEvent2&3RuleBook.png' />}
        {nowSection === 'C' && <WodImage src='https://picture.link-zone.org/event/GorillaThrowdown/GorillaEvent4RuleBook.png' />}
      </WodImageWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 100%;

  background-color: #FFFFFF;
`;

const TopLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 90.33%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 20px;

  width: 100%;
`;

const SectionButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 90.33%;
`;

const SectionButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-right: 8px;

  width: 69px;
  height: 32px;

  border-radius: 8px;
  background-color: ${props => props.isClicked ? `#6DD49E` : `#E0E0E0`};

  :hover {
    cursor: pointer;
  }
  
  transition: all 0.3s ease-in-out;
`;

const TotalSectionAButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-right: 8px;

  width: 32px;
  height: 32px;

  border-radius: 8px;
  background-color: ${props => props.isClicked ? `#FF8B48` : `#FF3131`};

  :hover {
    cursor: pointer;
  }
  
  transition: all 0.3s ease-in-out;
`;

const TotalSectionBButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-right: 8px;

  width: 32px;
  height: 32px;

  border-radius: 8px;
  background-color: ${props => props.isClicked ? `#FF8B48` : `#2F80ED`};

  :hover {
    cursor: pointer;
  }
  
  transition: all 0.3s ease-in-out;
`;

const CrownImage = styled.img`
  width: 22px;
  height: 19px;
`;

const DivisionLine = styled.div`
  width: 90.33%;
  height: 1px;

  margin: 20px 0px 20px 0px;

  background-color: #E0E0E0;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: default;
  }
`;

const TotalSectionButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-right: 8px;

  width: 32px;
  height: 32px;

  border-radius: 8px;
  background-color: #FFB800;

  :hover {
    cursor: pointer;
  }
  
  transition: all 0.3s ease-in-out;
`;

const WodImageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  // margin-top: 18px;

  // width: 90.33%;
  width: 100%;
  height: auto;

  overflow: hidden;
`;

const WodImage = styled.img`
  width: 100%;
  height: 100%;
`;

const RuleBookTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  aligna-items: flex-start;

  margin: 8px 0px 12px 0px;

  width: 90.33%;
`;
const WaitWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 74px;
`;

const WaitImage = styled.img`
  width: 148px;
  height: 62px;

  :hover {
    cursor: default;
  }
`;

// const TitleWrapper = styled.div`
//   display: flex;
//   flex-direction: row;

//   justify-content: space-between;
//   align-items: center;

//   width: 90.33%;
// `;

const SectionBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-right: 8px;

  width: 69px;
  height: 32px;

  border-radius: 6px;
  background-color: #6DD49E;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;

  // justify-content: space-between;
  justify-content: flex-start;
  align-items: center;

  // padding: 0px 12px 0px 12px;
  padding: 0px 8px 0px 8px;
  // padding: 0px 3px 0px 3px;
  margin: 0px 0px 0px 0px;

  // width: calc(90.33% - 69px);
  width: calc(100% - 69px);
  height: 32px;

  border-radius: 6px;
  background-color: #F9F9F9;
`;
